import axiosInstance from '@/plugins/axios';

export default class ServiceEmpresas {
  static listar = () => axiosInstance.get('empresas');
  static detalhe = (cnpj) => axiosInstance.get(`empresas/${cnpj}`);
}
